import {
  FETCH_PLACEMENTS_REQUEST,
  FETCH_PLACEMENTS_SUCCESS,
  FETCH_PLACEMENTS_FAIL,
  CREATE_PLACEMENT_REQUEST,
  CREATE_PLACEMENT_SUCCESS,
  CREATE_PLACEMENT_FAIL,
  UPDATE_PLACEMENT_REQUEST,
  UPDATE_PLACEMENT_SUCCESS,
  UPDATE_PLACEMENT_FAIL,
  DELETE_PLACEMENT_REQUEST,
  DELETE_PLACEMENT_SUCCESS,
  DELETE_PLACEMENT_FAIL,
} from '../../store/types';

const initialState = {
  loading: false,
  error: null,
  placements: [],
  total: 0,
  page: 1,
  pageSize: 20,
};

const placementReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PLACEMENTS_REQUEST:
    case CREATE_PLACEMENT_REQUEST:
    case UPDATE_PLACEMENT_REQUEST:
    case DELETE_PLACEMENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_PLACEMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        placements: action.payload.items,
        total: action.payload.total,
        page: action.payload.page,
        pageSize: action.payload.pageSize,
        error: null,
      };

    case CREATE_PLACEMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        placements: [...state.placements, action.payload],
        error: null,
      };

    case UPDATE_PLACEMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        placements: state.placements.map((p) =>
          p.id === action.payload.id ? action.payload : p
        ),
        error: null,
      };

    case DELETE_PLACEMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        placements: state.placements.filter((p) => p.id !== action.payload),
        error: null,
      };

    case FETCH_PLACEMENTS_FAIL:
    case CREATE_PLACEMENT_FAIL:
    case UPDATE_PLACEMENT_FAIL:
    case DELETE_PLACEMENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default placementReducer;
